export default __webpack_public_path__ + "static/congo-wong-bg-544fd5c0240ec5d138d7946d59a8f117.webp";